const KEY_PREFIX = 'dockSchedulerSettings_'

const getDefaultSettings = () => ({
    widescreenMode: false,
    horizontalScroll: false,
    minDockColumnWidth: 120,
    dockGroups: [],
    settingsSeen: false,
    showDockTypeOnHeader: true
})

const getSettings = (locationId) => {
    try {
        const raw = localStorage.getItem(KEY_PREFIX + locationId)
        if (!raw) return getDefaultSettings()
        const parsed = JSON.parse(raw)
        // Merge with defaults so older saved configs gain new fields
        return { ...getDefaultSettings(), ...parsed }
    } catch {
        return getDefaultSettings()
    }
}

const saveSettings = (locationId, settings) => {
    localStorage.setItem(KEY_PREFIX + locationId, JSON.stringify(settings))
    return settings
}

const managerSettingsFns = { getSettings, saveSettings, getDefaultSettings }

export default managerSettingsFns
